export const ORDER_ITEMS = {
  MUTATIONS: {
    SET_LIST: 'order-items-set-list'
  },
  ACTIONS: {
    CHANGE_ITEM: 'order-items-action-change-item',
    CLEAR_STORE: 'order-items-action-clear'
  },
  GETTERS: {
    LIST: 'order-items-get-list'
  }
}
